import { render, staticRenderFns } from "./blogList.vue?vue&type=template&id=5fc0be1a&scoped=true&lang=html&"
import script from "./blogList.vue?vue&type=script&lang=js&"
export * from "./blogList.vue?vue&type=script&lang=js&"
import style0 from "./blogList.vue?vue&type=style&index=0&id=5fc0be1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0be1a",
  null
  
)

export default component.exports